document.addEventListener("DOMContentLoaded", function () {
  // ヘッダーメニューをSP/PCで挙動切り替えするための境界値
  var menuBreakpoint = 960;
  var mediaQuery = window.matchMedia("(max-width: " + menuBreakpoint + "px)");
  // ヘッダー内の親リンク（SP時は開閉トリガーとして利用）
  var parentLinks = document.querySelectorAll(
    ".menu_unit .menu_btn",
  );
  // ブレークポイントを跨いだか判定するため、初期状態を保持
  var wasSp = mediaQuery.matches;

  if (parentLinks.length === 0) return;

  // 開いているメニューアコーディオンをすべて閉じる
  function closeAllMenuAccordions() {
    var units = document.querySelectorAll(".menu_unit");

    units.forEach(function (unit) {
      var link = unit.querySelector(".menu_btn");
      var content = unit.querySelector(".menu_content");

      unit.classList.remove("-open");

      if (content) {
        content.classList.remove("-open");
        content.setAttribute("aria-hidden", "true");
      }

      if (link) {
        link.setAttribute("aria-expanded", "false");
      }
    });
  }
  parentLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      // PC時は常に通常リンクとして動作
      if (!mediaQuery.matches) return;

      var unit = link.closest(".menu_accordion_unit");
      if (!unit) {
        unit = link.closest(".menu_unit");
      }
      if (!unit) return;

      var content = unit.querySelector(".menu_content");
      if (!content) return;

      var isOpen = unit.classList.contains("-open");

      // SP時は親リンクのタップで開閉のみ（遷移はサブメニューから）
      event.preventDefault();
      if (!isOpen) {
        unit.classList.add("-open");
        content.classList.add("-open");
        content.setAttribute("aria-hidden", "false");
        link.setAttribute("aria-expanded", "true");
      } else {
        unit.classList.remove("-open");
        content.classList.remove("-open");
        content.setAttribute("aria-hidden", "true");
        link.setAttribute("aria-expanded", "false");
      }
    });
  });

  // SP/PC を跨いだときだけ開閉状態をリセットする
  function handleBreakpointChange() {
    var isSp = mediaQuery.matches;
    if (isSp !== wasSp) {
      closeAllMenuAccordions();
      wasSp = isSp;
    }
  }

  if (typeof mediaQuery.addEventListener === "function") {
    // モダンブラウザ向け
    mediaQuery.addEventListener("change", handleBreakpointChange);
  } else if (typeof mediaQuery.addListener === "function") {
    // 旧ブラウザ向けフォールバック
    mediaQuery.addListener(handleBreakpointChange);
  }
});
